import { FlashList, ListRenderItem } from "@shopify/flash-list";
import { useCallback, useMemo } from "react";
import ListFooterComponent from "src/components/ListFooterComponent";
import useEditCoverGalleryPadding from "src/screens/(internal)/EditCoverGalleryModal/hooks/useEditCoverGalleryPadding";
import { EditCoverGatheringPhotosTabConfig } from "src/screens/(internal)/EditCoverGalleryModal/types";
import { paddingLarge, paddingMedium, paddingXL } from "src/styles/spacing";
import { useSafeArea } from "src/swsh-native";
import EditCoverGatheringPhoto from "./components/EditCoverGatheringPhoto";
import useEditCoverGatheringPhotos from "./hooks/useEditCoverGatheringPhotos";
import { EditCoverGatheringPhotoType } from "./types";

const itemSpacing = paddingLarge;
const EditCoverGatheringPhotosContent = ({
	config,
	width,
}: {
	config: EditCoverGatheringPhotosTabConfig;
	width: number;
}) => {
	const { photos, loading, fetchMore, refresh, refreshing } = useEditCoverGatheringPhotos(
		config.gatheringId,
	);

	const numColumns = useMemo(() => {
		return Math.max(Math.floor(width / 225), 2);
	}, [width]);
	const { paddingHorizontal } = useEditCoverGalleryPadding();
	const itemSize = useMemo(() => {
		return (width - paddingHorizontal * 2 - (numColumns - 1) * itemSpacing) / numColumns;
	}, [numColumns, paddingHorizontal, width]);
	const safeArea = useSafeArea();

	const editCoverPosterListRenderItem: ListRenderItem<EditCoverGatheringPhotoType> = useCallback(
		({ item, extraData }) => {
			return (
				<EditCoverGatheringPhoto
					photo={item}
					width={extraData.itemWidth as number}
					height={extraData.itemHeight as number}
					marginBottom={extraData.marginBottom as number}
					config={config}
				/>
			);
		},
		[config],
	);

	return (
		<>
			<FlashList
				estimatedItemSize={itemSize}
				extraData={{
					itemWidth: itemSize,
					itemHeight: itemSize,
					marginBottom: itemSpacing,
				}}
				data={photos}
				numColumns={numColumns}
				renderItem={editCoverPosterListRenderItem}
				keyExtractor={(photo) => photo.photoId}
				contentContainerStyle={{
					paddingTop: paddingXL,
					paddingBottom: safeArea.bottom + paddingMedium,
					// Hack to get things to space evenly
					// The problem is that each item is left aligned in its own cell
					paddingLeft: paddingHorizontal,
					paddingRight: -itemSpacing + paddingHorizontal,
				}}
				onEndReached={fetchMore}
				onEndReachedThreshold={0.8}
				onRefresh={refresh}
				refreshing={refreshing}
				ListFooterComponent={<ListFooterComponent loading={loading} />}
			/>
		</>
	);
};
export default EditCoverGatheringPhotosContent;
